import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { StripeProvider } from 'react-stripe-elements';
import 'intl';
import 'vunit.js';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { fromJS } from 'immutable';

import 'redux/localStorage';
import configureStore from 'redux/store';
import I18n from 'components/I18n';
import 'styles/app.scss';

import Router from 'router';
import { STRIPE } from 'constants/options';

const initialState = fromJS({});
const store = configureStore(initialState);
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#4695ec', // bordered TextField border color
      dark: '#4695ec', // underlined TextField active underline color
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const currentUrl = window.location.href;
if (currentUrl.indexOf('https://freshr.com') >= 0 || currentUrl.indexOf('http://freshr.com') >= 0) {
  window.location.href = currentUrl.replace('https://freshr.com', 'https://www.freshr.com').replace('http://freshr.com', 'https://www.freshr.com');
}

// const publishableKey = currentUrl.indexOf('https://www.freshr.com') >= 0 || currentUrl.indexOf('https://stage2.freshr.com') >= 0 ?
//   STRIPE.api.publishableKey.live : STRIPE.api.publishableKey.test;

const publishableKey = currentUrl.indexOf('https://www.freshr.com') >= 0 ?
  STRIPE.api.publishableKey.live : STRIPE.api.publishableKey.test;

  // eslint-disable-next-line no-undef, new-cap
new vUnit({
  CSSMap: {
    '.vh_height': { property: 'height', reference: 'vh' },
  },
}).init();

render(
  <MuiPickersUtilsProvider utils={MomentUtils}>
    <MuiThemeProvider theme={theme}>
      <StripeProvider apiKey={publishableKey}>
        <Provider store={store}>
          <I18n>
            <Router />
          </I18n>
        </Provider>
      </StripeProvider>
    </MuiThemeProvider>
  </MuiPickersUtilsProvider>,
  document.getElementById('app-container'),
);
